import {
  Container,
  Box,
  Paper,
  TablePagination,
  TableContainer,
  Table,
  TableBody,
  TableRow,
  TableCell
} from "@mui/material";
import MRTableHeaders from "../components/MRTableHeaders";
import MRTableRow from "../components/MRTableRow";
import { useMRTable } from "../hooks/useMRTable";
import StoreContext from "../context/StoreContext";
import { useEffect, useContext } from "react";
import { useLyftTableCols } from "../hooks/useLyftTableCols";
import MRTableSearchToolbar from "../components/MRTableSearchToolbar";
import { useState } from "react";
import { useBebackApi } from "../hooks/useBebackApi";
import FeedbackContext from "../context/FeedbackContext";
import { useHistory } from 'react-router-dom';
import { ArrowBackIos } from "@mui/icons-material";
import FeedbackPopUp from "../components/FeedbackPopUp";
import WarningModal from "../components/WarningModal";

function LyftSettings() {
  const { storeList, setStoreList } = useContext(StoreContext);
  const { setIsLoading } = useContext(FeedbackContext);
  const [searchedValue, setSearchedValue] = useState('');
  const [showPopup, setShowPopup] = useState(false);
  const [formValues, setFormValues] = useState(null);
  const [storeToUpdate, setStoreToUpdate] = useState('');
  const [showSaveModal, setShowSaveModal] = useState(false);
  const {
    requestSearch,
    emptySearch,
    visibleRows,
    order,
    orderBy,
    setOrderBy,
    handleRequestSort,
    page,
    rowsPerPage,
    handleChangePage,
    handleChangeRowsPerPage,
    rowsCount
  } = useMRTable(storeList, searchedValue, setSearchedValue, '', 'StoreList');
  const { manageLyftStoreDetails } = useBebackApi();
  const history = useHistory();

  const updateLyftSettings = async () => {
    try {
      setIsLoading(true)
      const reqBody = {
        store_id: storeToUpdate,
        lyft_url: formValues.lyft_url,
        lyft_program_id: formValues.lyft_program_id
      }
      const response = await manageLyftStoreDetails(reqBody);
      return response;
    } catch (error) {
      console.log(error);
      return error
    } finally {
      setIsLoading(false)
    }
  }

  const onConfirmModalOpen = (formSettings, storeId) => {
    setStoreToUpdate(storeId)
    setFormValues(formSettings);
    setShowSaveModal(true)
  }

  const { columns: LyftTableCols, handleUndo, cancelEditMode } = useLyftTableCols({ onConfirmModalOpen, page });

  useEffect(() => {
    setOrderBy('value')
  }, [])

  const handleSaveLyftSettings = async () => {
    const response = await updateLyftSettings();
    if(response?.error) {
      setShowPopup(true)
    } else {
      const updatedStoreList = storeList.map((store) => {
        if (store.value === storeToUpdate) {
          return {
            ...store,
            lyft_url: formValues.lyft_url,
            lyft_program_id: formValues.lyft_program_id
          };
        }
        return store;
      });
      setStoreList(updatedStoreList);
    }
    setShowSaveModal(false);
    cancelEditMode(storeToUpdate)
  }
  
  const onCloseSaveModal = () => {
    const storeSettings = storeList.find((store) => store.value === storeToUpdate)
    handleUndo(storeToUpdate, storeSettings)
    setShowSaveModal(false);
  }

  const goToHome = () => {
    history.push('/home');
  };

  return (
    <Container className="items-end mb-10">
      <Box className='cursor-pointer' onClick={goToHome}>
        <ArrowBackIos fontSize="small" />
        <span className='settings-home'>Home</span>
      </Box>
      <Box className='flex items-center justify-between'>
        <Box className='title-container'>
          Lyft Settings
        </Box>
        <MRTableSearchToolbar
          value={searchedValue}
          onChange={search => requestSearch(search.target.value)}
          clearSearch={emptySearch}
          placeholder={`Search Store`}
        />
      </Box>
      <TableContainer component={Paper}>
        <Table aria-label="collapsible table">
          <MRTableHeaders
            order={order}
            orderBy={orderBy}
            onRequestSort={handleRequestSort}
            MRcols={LyftTableCols}
          />
          <TableBody>
            {
              visibleRows.length > 0
                ?
                visibleRows.map((row, index) => (
                  <MRTableRow
                    key={index}
                    row={row}
                    index={index}
                    MRcols={LyftTableCols}
                  />
                ))
                :
                <TableRow sx={{ height: 360 }}>
                  <TableCell colSpan={2} align='center'>
                    No records to display.
                  </TableCell>
                </TableRow>
            }
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[10, 25, 35, 50]}
        component="div"
        count={rowsCount}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
        showFirstButton
        showLastButton
        className='table-pagination border border-solid border-gray-200 rounded-b-md'
      />

      {
        showPopup && 
        <FeedbackPopUp
          open={showPopup}
          onClose={() => setShowPopup(false)}
          title='Something went wrong!'
          message='Service unavailable. Please try again later.'
          type='errror'
        />
      }

      {
        showSaveModal &&
        <WarningModal
          open={showSaveModal}
          onClose={onCloseSaveModal}
          warningText={`Are you sure you want to update the Lyft settings?`}
          confirmation={handleSaveLyftSettings}
        />
      }

    </Container>
  )
}

export default LyftSettings;